@import '../../themes/graphite.globals';

:host {
  /**
   * @prop --margin-between-fields: Margin between the children
   * @prop --margin-between-fields-horizontal: Margin between the children when layout is horizontal
   * @prop --align-fields: Alignment of fields on cross-axis, an `align-items` Flexbox property
   */
  --margin-between-fields: var(--gr-spacing-xx-small);
  --margin-between-fields-horizontal: var(--gr-spacing-medium);
  --align-fields: flex-start;

  display: block;
  box-sizing: border-box;

  & *,
  & *:before,
  & *:after {
    box-sizing: inherit;
  }
}

.field-group {
  margin: 0;
  padding: 0;
  border: none;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: var(--align-fields);
  gap: var(--margin-between-fields);
}

.field-group-horizontal .content {
  flex-direction: row;
  gap: var(--margin-between-fields-horizontal);
}

.field-group-label {
  display: none;
}

.field-group-has-label {
  .field-group-label {
    line-height: var(--gr-line-height-normal);
    color: var(--gr-form-element-label-color);
    margin-bottom: var(--gr-spacing-xxx-small);
    font-size: var(--gr-form-element-label-font-size-medium);

    margin: 0;
    padding: 0;
    display: flex;

    margin-bottom: var(--gr-spacing-xxx-small);
  }
}
